import {VoipService} from "./VoipService";

export class Transaction {
    constructor({
                    ubCustNo = null,
                    csn = null,
                    description = null,
                    charge = null,
                    chargeDate = null,
                    success = null,
                    reason = null,
                } = {}) {
        this.ubCustNo = ubCustNo;
        this.csn = csn;
        this.description = description;
        this.charge = charge;
        this.chargeDate = chargeDate;
        this.success = success;
        this.reason = reason;
    }
}
export function createTransaction(data) {
    return Object.freeze(new Transaction(data));
}
export function createTransactionWithHeaderName(data) {
    return new Transaction({
        ubCustNo: data.UBCustNo,
        csn: data.Csn,
        description: data.Description,
        charge: data.Charge,
        chargeDate: data.ChargeDate
    });
}